import { Component, inject, OnInit } from '@angular/core';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxContextMenuModule } from '@aposin/ng-aquila/context-menu';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Cookies from 'js-cookie';

export const PREFERRED_LANGUAGE_COOKIE_NAME = 'locale';
export const PREFERRED_LANGUAGE_COOKIE_DURATION_IN_DAYS = 365;

@Component({
  selector: 'kyc-locale-selector',
  imports: [NxContextMenuModule, NxIconModule, NxButtonModule, TranslateModule],
  templateUrl: './locale-selector.component.html',
})
export class LocaleSelectorComponent implements OnInit {
  private readonly translateService = inject(TranslateService);

  protected selectedLanguage?: string;

  protected availableLanguages = [
    { label: 'English (UK)', value: 'en-GB' },
    { label: 'English (US)', value: 'en-US' },
    { label: 'Français', value: 'fr-FR' },
    { label: 'Deutsch', value: 'de-DE' },
    { label: 'Italiano', value: 'it-IT' },
  ];

  ngOnInit(): void {
    this.selectedLanguage = this.translateService.currentLang;
  }

  protected onSelectLanguage(language: string) {
    this.selectedLanguage = language;
    this.translateService.use(language);
    Cookies.set(PREFERRED_LANGUAGE_COOKIE_NAME, language, { expires: PREFERRED_LANGUAGE_COOKIE_DURATION_IN_DAYS });
  }
}
